var Partners = {

	init: function () {
		var $slider = $('.partners-slider');
        $slider.slick({
			dots: false,
			arrows: false,
			nav: false,
			autoplay: true,
  			autoplaySpeed: 2000,
			infinite: true,
			speed: 500, 
			slidesToShow: 1,
			slidesToScroll: 1,			
	  		cssEase: 'linear',	
	  		swipeToSlide: true,
	  		variableWidth: true		
		});
	},    
};